/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
import { useDispatch } from 'react-redux'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Box } from '@mui/material'
import Footer from './Footer'
import { updateListing } from '../../../../../redux/actions'
import { MUIFormTextInput } from '../../../../@Common/Form/TextInput/FormTextInput'

export function DefaultRedirectSection({ listing }) {
  const dispatch = useDispatch()
  const { control, handleSubmit } = useForm({
    defaultValues: {
      defaultOfflineRedirectUrl: listing.defaultOfflineRedirectUrl,
    },
  })

  const onSubmit = (values) => {
    dispatch(updateListing({ ...listing, defaultOfflineRedirectUrl: values.defaultOfflineRedirectUrl }))
  }

  return (
    <div style={{ position: 'relative' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="h2" style={{ margin: '0px', padding: '15px 0px', fontSize: '20px' }}>Default Redirect</Typography>
        <Box
          style={{ margin: '10px 0px' }}
        >
          <MUIFormTextInput
            control={control}
            name="defaultOfflineRedirectUrl"
            label="Default Offline Redirect URL"
            rules={{
              required: true,
              pattern: {
                value: /^https?:\/\/.+/i,
                message: 'URL must start with "http://" or "https://".',
              },
            }}
          />
        </Box>
        <Footer label="Save" processing={false} onSubmit={handleSubmit(onSubmit)} />
      </form>
    </div>
  )
}

export default DefaultRedirectSection
